import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { LayoutComponent } from './components/layout/layout.component';
import { FormulaireComponent } from './components/formulaire/formulaire.component';
import { MentionsLegalesComponent } from './components/mentions-legales/mentions-legales.component';
import { LangueResolverService } from './core/resolvers/langue.resolver';
import { ProtectionDonneesComponent } from './components/protection-donnees/protection-donnees.component';

const appRoutes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: FormulaireComponent,
        resolve: { LangueResolverService },
      },
      {
        path: 'fr',
        component: FormulaireComponent,
        resolve: { LangueResolverService },
      },
      {
        path: 'en',
        component: FormulaireComponent,
        resolve: { LangueResolverService },
      },
      {
        path: 'ar',
        component: FormulaireComponent,
        resolve: { LangueResolverService },
      },
      {
        path: 'ru',
        component: FormulaireComponent,
        resolve: { LangueResolverService },
      },
      {
        path: 'mentions-legales',
        component: MentionsLegalesComponent,
        resolve: { LangueResolverService },
      },
      {
        path: 'protection-donnees',
        component: ProtectionDonneesComponent,
        resolve: { LangueResolverService },
      }
    ]
  }
];

export const routing = RouterModule.forRoot(appRoutes);

export const routedComponents = [AppComponent];
